import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../commons/Auth';
import LogoExtra from '../../images/logo-extra.png';
import LogoExtraBit from '../../images/logo-extra-bit.png';
import { ReactComponent as IconDashboard } from '../../images/icn_dashboard.svg';
import { ReactComponent as IconRegistries } from '../../images/icn_anagrafiche.svg';
import { ReactComponent as IconInvoices } from '../../images/icn_fatture.svg';
import { ReactComponent as IconPolizza } from '../../images/icn_polizza.svg';
import { ReactComponent as IconFinancial } from '../../images/icn_rendicontazioni.svg';
import { ReactComponent as IconProfile } from '../../images/icn_profilo.svg';
import { ReactComponent as IconAffiliations } from '../../images/icn-incontro.svg';
import { ReactComponent as IconLogs } from '../../images/icn-edit.svg';
import { ReactComponent as IconCalendar } from '../../images/icn-calendar.svg';
import { ReactComponent as IconBuilding } from '../../images/icn_buildings.svg';
import { ReactComponent as IcnDocument } from '../../images/icn_document.svg';
import { ReactComponent as IconNetwork } from '../../images/icn-incontro.svg';
import { BsChatDots, BsQrCode } from 'react-icons/bs';
import {
  FINANCIAL_REPORTS_ALLOWED_TYPES,
  AFFILIATIONS_ALLOWED_TYPES,
  INVOICES_ALLOWED_TYPES,
  ROYALTIES_ALLOWED_TYPES,
  INSURANCES_ALLOWED_TYPES,
  ENERGY_USERS,
  CUSTOMERS_ALLOWED_TYPES,
  CUSTOMERS_CONDOS_ALLOWED_TYPES,
  ADMIN_TYPES,
  AGENT_TYPES,
  USER_ADMIN_TYPES,
  CERTIFIER_TYPE,
} from '../../App';
import './LinkMenu.scss';

function LinkMenu({ match }) {
  const [t] = useTranslation('PAGES');

  const { url } = match || {};
  const [
    { newIsAdmin = false, newUserType = '', profile = {} } = {},
  ] = useAuth();
  const { type: profileType = '', commercial = false } = profile;

  const [dropdownsOpen, setDropdownsOpen] = useState({});
  const toggleDropdown = (key) => {
    setDropdownsOpen((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const getActive = (url = '', paths = []) => {
    return paths.some((path) => url.startsWith(path)) ? 'active' : '';
  };

  const REACT_APP_ID = process.env.REACT_APP_ID || 'franchising-extra';

  return (
    <>
      <div className="cont-logo-menu">
        <img src={LogoExtraBit} alt="Extra Franchising" />
      </div>
      <div className="cont-link-menu">
        {newIsAdmin && newUserType === 'SUPER_ADMIN' && (
          <Link to={'/dashboard'} className={getActive(url, ['/dashboard'])}>
            <IconDashboard className="hover-color" /> {t('DASHBOARD')}
          </Link>
        )}

        {newIsAdmin && (
          <div style={{ marginBottom: 25 }}>
            <button
              type="button"
              className={
                'link-menu-btn d-flex align-items-center ' +
                getActive(url, [
                  '/profiles',
                  '/profile-detail',
                  '/historic',
                  '/historic/:id',
                ])
              }
              onClick={() => toggleDropdown('personalData')}
              style={{
                textAlign: 'left',
                paddingLeft: 0,
                background: 'none',
                border: 'none',
                width: '100%',
              }}
            >
              <span
                style={{
                  marginLeft: 8,
                  marginRight: 15,
                  transition: 'transform 0.2s',
                }}
              >
                <i
                  className="fas fa-chevron-right hover-color"
                  style={{
                    transform: dropdownsOpen.personalData
                      ? 'rotate(90deg)'
                      : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                  }}
                />
              </span>
              <span className="hover-color">{t('PAGES:REGISTRIES')}</span>
            </button>
            {dropdownsOpen.personalData && (
              <div className="submenu-links">
                <Link
                  to={'/profiles'}
                  className={getActive(url, ['/profiles', '/profile-detail'])}
                >
                  <IconRegistries className="hover-color" />{' '}
                  {t('REGISTRIES_PROFILES')}
                </Link>
                <Link
                  to={'/historic'}
                  className={getActive(url, ['/historic', '/historic/:id'])}
                >
                  <IconRegistries className="hover-color" />{' '}
                  {t('HISTORIC_PROFILES')}
                </Link>
              </div>
            )}
          </div>
        )}

        {newIsAdmin && (
          <Link to={'/archive'} className={getActive(url, ['/archive'])}>
            <IconInvoices className="hover-color" style={{ height: '23px' }} />{' '}
            {t('ARCHIVE')}
          </Link>
        )}

        {newIsAdmin && (
          <Link to={'/condos'} className={getActive(url, ['/condos'])}>
            <IconBuilding className="hover-color" /> {t('PAGES:CONDOS')}
          </Link>
        )}

        {newIsAdmin && (
          <Link
            to={'/customer-extra-masters'}
            className={getActive(url, ['/customer-extra-masters'])}
          >
            <IconProfile className="hover-color" /> {t('PAGES:CUSTOMER_EXTRA')}
          </Link>
        )}

        {newIsAdmin && (
          <Link
            to={'/offices-extra-masters'}
            className={getActive(url, ['/offices-extra-masters'])}
          >
            <IconProfile className="hover-color" /> {t('PAGES:OFFICES')}
          </Link>
        )}

        {newIsAdmin && (
          <Link
            to={'/contracts-admin'}
            className={getActive(url, ['/contracts-admin'])}
          >
            <IcnDocument className="hover-color" /> {t('CONTRACTS')}
          </Link>
        )}

        {newIsAdmin && (
          <Link
            to={'/signals-admin'}
            className={getActive(url, ['/signals-admin'])}
          >
            <IcnDocument className="hover-color" /> {t('PAGES:SIGNALS')}
          </Link>
        )}

        {newIsAdmin && (
          <div style={{ marginBottom: 25 }}>
            <button
              type="button"
              className={
                'link-menu-btn d-flex align-items-center ' +
                getActive(url, [
                  '/activities-admin',
                  '/agreements-admin',
                  '/external-agreements-admin',
                ])
              }
              onClick={() => toggleDropdown('agreementsAdmin')}
              style={{
                textAlign: 'left',
                paddingLeft: 0,
                background: 'none',
                border: 'none',
                width: '100%',
              }}
            >
              <span
                style={{
                  marginLeft: 8,
                  marginRight: 15,
                  transition: 'transform 0.2s',
                }}
              >
                <i
                  className="fas fa-chevron-right hover-color"
                  style={{
                    transform: dropdownsOpen.agreementsAdmin
                      ? 'rotate(90deg)'
                      : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                  }}
                />
              </span>
              <span className="hover-color">{t('PAGES:AGREEMENTS_MENU')}</span>
            </button>
            {dropdownsOpen.agreementsAdmin && (
              <div className="submenu-links">
                <Link
                  to="/activities-admin"
                  className={
                    getActive(url, ['/activities-admin']) + ' submenu-link'
                  }
                >
                  <IcnDocument className="hover-color" />
                  {t('PAGES:ACTIVITIES')}
                </Link>
                <Link
                  to="/agreements-admin"
                  className={
                    getActive(url, ['/agreements-admin']) + ' submenu-link'
                  }
                >
                  <IcnDocument className="hover-color" />
                  {t('PAGES:AGREEMENTS')}
                </Link>
                <Link
                  to="/external-agreements-admin"
                  className={
                    getActive(url, ['/external-agreements-admin']) +
                    ' submenu-link'
                  }
                >
                  <IcnDocument className="hover-color" />
                  {t('PAGES:EXTERNAL_AGREEMENTS')}
                </Link>
              </div>
            )}
          </div>
        )}

        {newIsAdmin && (
          <div style={{ marginBottom: 25 }}>
            <button
              type="button"
              className={
                'link-menu-btn d-flex align-items-center ' +
                getActive(url, ['/insurances-admin', '/claims-admin'])
              }
              onClick={() => toggleDropdown('insurances')}
              style={{
                textAlign: 'left',
                paddingLeft: 0,
                background: 'none',
                border: 'none',
                width: '100%',
              }}
            >
              <span
                style={{
                  marginLeft: 8,
                  marginRight: 15,
                  transition: 'transform 0.2s',
                }}
              >
                <i
                  className="fas fa-chevron-right hover-color"
                  style={{
                    transform: dropdownsOpen.insurances
                      ? 'rotate(90deg)'
                      : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                  }}
                />
              </span>
              <span className="hover-color">{t('PAGES:INSURANCES_MENU')}</span>
            </button>
            {dropdownsOpen.insurances && (
              <div className="submenu-links">
                <Link
                  to="/insurances-admin"
                  className={
                    getActive(url, ['/insurances-admin']) + ' submenu-link'
                  }
                >
                  <IconPolizza className="hover-color" />
                  {t('PAGES:INSURANCES_MENU_PAGE')}
                </Link>
                <Link
                  to="/claims-admin"
                  className={
                    getActive(url, ['/claims-admin']) + ' submenu-link'
                  }
                >
                  <IcnDocument className="hover-color" />
                  {t('PAGES:CLAIMS_MENU_PAGE')}
                </Link>
              </div>
            )}
          </div>
        )}

        {newIsAdmin && newUserType !== USER_ADMIN_TYPES.SUPERVISOR_USER && (
          <div style={{ marginBottom: 25 }}>
            <button
              type="button"
              className={
                'link-menu-btn d-flex align-items-center ' +
                getActive(url, ['/by-month', '/panoramica-by-month'])
              }
              onClick={() => toggleDropdown('byMonth')}
              style={{
                textAlign: 'left',
                paddingLeft: 0,
                background: 'none',
                border: 'none',
                width: '100%',
              }}
            >
              <span
                style={{
                  marginLeft: 8,
                  marginRight: 15,
                  transition: 'transform 0.2s',
                }}
              >
                <i
                  className="fas fa-chevron-right hover-color"
                  style={{
                    transform: dropdownsOpen.byMonth
                      ? 'rotate(90deg)'
                      : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                  }}
                />
              </span>
              <span className="hover-color">
                {t('PAGES:INVOICES_BY_MONTH_MENU')}
              </span>
            </button>
            {dropdownsOpen.byMonth && (
              <div className="submenu-links">
                <Link
                  to="/by-month"
                  className={getActive(url, ['/by-month']) + ' submenu-link'}
                >
                  <IconCalendar className="hover-color" />
                  {t('PAGES:EXTRA_INVOICES_BY_MONTH_MENU')}
                </Link>
                <Link
                  to="/panoramica-by-month"
                  className={
                    getActive(url, ['/panoramica-by-month']) + ' submenu-link'
                  }
                >
                  <IconCalendar className="hover-color" />
                  {t('PAGES:PANORAMICA_INVOICES_BY_MONTH_MENU')}
                </Link>
              </div>
            )}
          </div>
        )}

        {newIsAdmin && newUserType !== USER_ADMIN_TYPES.SUPERVISOR_USER && (
          <div style={{ marginBottom: 25 }}>
            <button
              type="button"
              className={
                'link-menu-btn d-flex align-items-center ' +
                getActive(url, [
                  '/iafs-by-month',
                  '/panoramica-iafs-by-month',
                  '/iafs-by-month-network',
                ])
              }
              onClick={() => toggleDropdown('iafsByMonth')}
              style={{
                textAlign: 'left',
                paddingLeft: 0,
                background: 'none',
                border: 'none',
                width: '100%',
              }}
            >
              <span
                style={{
                  marginLeft: 8,
                  marginRight: 15,
                  transition: 'transform 0.2s',
                }}
              >
                <i
                  className="fas fa-chevron-right hover-color"
                  style={{
                    transform: dropdownsOpen.iafsByMonth
                      ? 'rotate(90deg)'
                      : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                  }}
                />
              </span>
              <span className="hover-color">
                {t('PAGES:IAFS_BY_MONTH_MENU')}
              </span>
            </button>
            {dropdownsOpen.iafsByMonth && (
              <div className="submenu-links">
                <Link
                  to={'/iafs-by-month'}
                  className={getActive(url, ['/iafs-by-month'])}
                >
                  <IconCalendar className="hover-color" />
                  {t('PAGES:EXTRA_IAF_BY_MONTH_MENU')}
                </Link>
                <Link
                  to="/panoramica-iafs-by-month"
                  className={
                    getActive(url, ['/panoramica-iafs-by-month']) +
                    ' submenu-link'
                  }
                >
                  <IconCalendar className="hover-color" />
                  {t('PAGES:PANORAMICA_IAF_BY_MONTH_MENU')}
                </Link>
                <Link
                  to="/iafs-by-month-network"
                  className={
                    getActive(url, ['/iafs-by-month-network']) + ' submenu-link'
                  }
                >
                  <IconCalendar className="hover-color" />
                  {t('PAGES:NETWORK_IAF_BY_MONTH_MENU')}
                </Link>
              </div>
            )}
          </div>
        )}

        {newIsAdmin &&
          (newUserType === 'SUPER_ADMIN' ||
            newUserType === USER_ADMIN_TYPES.SUPERVISOR) && (
            <div style={{ marginBottom: 25 }}>
              <button
                type="button"
                className={
                  'link-menu-btn d-flex align-items-center ' +
                  getActive(url, [
                    '/my-emitted-iaf',
                    '/panoramica-my-emitted-iaf',
                  ])
                }
                onClick={() => toggleDropdown('myEmittedIAF')}
                style={{
                  textAlign: 'left',
                  paddingLeft: 0,
                  background: 'none',
                  border: 'none',
                  width: '100%',
                }}
              >
                <span
                  style={{
                    marginLeft: 8,
                    marginRight: 15,
                    transition: 'transform 0.2s',
                  }}
                >
                  <i
                    className="fas fa-chevron-right hover-color"
                    style={{
                      transform: dropdownsOpen.myEmittedIAF
                        ? 'rotate(90deg)'
                        : 'rotate(0deg)',
                      transition: 'transform 0.2s',
                    }}
                  />
                </span>
                <span className="hover-color">{t('MY_EMITTED_IAF_MENU')}</span>
              </button>
              {dropdownsOpen.myEmittedIAF && (
                <div className="submenu-links">
                  <Link
                    to="/my-emitted-iaf"
                    className={
                      getActive(url, ['/my-emitted-iaf']) + ' submenu-link'
                    }
                  >
                    <IconInvoices
                      className="hover-color"
                      style={{ height: '23px' }}
                    />
                    {t('MY_EMITTED_IAF_EXTRA')}
                  </Link>
                  <Link
                    to="/panoramica-my-emitted-iaf"
                    className={
                      getActive(url, ['/panoramica-my-emitted-iaf']) +
                      ' submenu-link'
                    }
                  >
                    <IconInvoices
                      className="hover-color"
                      style={{ height: '23px' }}
                    />
                    {t('MY_EMITTED_IAF_PANORAMICA')}
                  </Link>
                </div>
              )}
            </div>
          )}

        {newIsAdmin && newUserType !== USER_ADMIN_TYPES.SUPERVISOR_USER && (
          <div style={{ marginBottom: 25 }}>
            <button
              type="button"
              className={
                'link-menu-btn d-flex align-items-center ' +
                getActive(url, ['/sail-invoices', '/panoramica-sail-invoices'])
              }
              onClick={() => toggleDropdown('sailInvoices')}
              style={{
                textAlign: 'left',
                paddingLeft: 0,
                background: 'none',
                border: 'none',
                width: '100%',
              }}
            >
              <span
                style={{
                  marginLeft: 8,
                  marginRight: 15,
                  transition: 'transform 0.2s',
                }}
              >
                <i
                  className="fas fa-chevron-right hover-color"
                  style={{
                    transform: dropdownsOpen.sailInvoices
                      ? 'rotate(90deg)'
                      : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                  }}
                />
              </span>
              <span className="hover-color">
                {t('PAGES:SAIL_INVOICES_MENU')}
              </span>
            </button>
            {dropdownsOpen.sailInvoices && (
              <div className="submenu-links">
                <Link
                  to="/sail-invoices"
                  className={
                    getActive(url, ['/sail-invoices']) + ' submenu-link'
                  }
                >
                  <IconInvoices
                    className="hover-color"
                    style={{ height: '23px' }}
                  />
                  {t('PAGES:SAIL_INVOICES_EXTRA_MENU')}
                </Link>
                <Link
                  to="/panoramica-sail-invoices"
                  className={
                    getActive(url, ['/panoramica-sail-invoices']) +
                    ' submenu-link'
                  }
                >
                  <IconInvoices
                    className="hover-color"
                    style={{ height: '23px' }}
                  />
                  {t('PAGES:SAIL_INVOICES_PANORAMICA_MENU')}
                </Link>
              </div>
            )}
          </div>
        )}

        {newIsAdmin &&
          (newUserType === 'SUPER_ADMIN' || newUserType === 'SUPERVISOR') && (
            <Link
              to={'/scheduled-reporting'}
              className={getActive(url, ['/scheduled-reporting'])}
            >
              <IconInvoices
                className="hover-color"
                style={{ height: '23px' }}
              />{' '}
              {t('PAGES:SCHEDULED_REPORTING')}
            </Link>
          )}

        {newIsAdmin &&
          (newUserType === 'SUPER_ADMIN' || newUserType === 'SUPERVISOR') && (
            <Link
              to={'/overdue-invoices'}
              className={getActive(url, ['/overdue-invoices'])}
            >
              <IconInvoices
                className="hover-color"
                style={{ height: '23px' }}
              />{' '}
              {t('PAGES:OVERDUE_INVOICES')}
            </Link>
          )}

        {newIsAdmin && (
          <Link to={'/logs'} className={getActive(url, ['/logs'])}>
            <IconLogs className="hover-color" />
            {t('PAGES:LOGS')}
          </Link>
        )}

        {!newIsAdmin && (
          <Link to={'/my-profile'} className={getActive(url, ['/my-profile'])}>
            <IconRegistries className="hover-color" /> {t('MY_PROFILE')}
          </Link>
        )}

        {!newIsAdmin &&
          (ADMIN_TYPES.includes(profileType) ||
            profile.type === 'ADMIN_COLLAB' ||
            profile.type === 'CERTIFIER') && (
            <Link to={'/my-condos'} className={getActive(url, ['/my-condos'])}>
              <IconBuilding className="hover-color" /> {t('CONDOS')}
            </Link>
          )}

        {!newIsAdmin && CUSTOMERS_CONDOS_ALLOWED_TYPES.includes(profileType) && (
          <Link
            to={'/partner-condos'}
            className={getActive(url, ['/partner-condos'])}
          >
            <IconBuilding className="hover-color" /> {t('CONDOS')}
          </Link>
        )}

        {!newIsAdmin &&
          [
            ...AGENT_TYPES,
            'COMMERCIAL',
            'ADMIN_COLLAB',
            'ASSOCIATION',
          ].includes(profileType) && (
            <Link
              to={'/customer-extra'}
              className={getActive(url, ['/customer-extra'])}
            >
              <IconProfile className="hover-color" style={{ height: '23px' }} />
              {t('PAGES:CUSTOMER_EXTRA')}
            </Link>
          )}

        {!newIsAdmin &&
          ['ASSOCIATION', 'SUPPLIER', 'EON_ENERGY'].includes(profileType) && (
            <Link to={'/offices'} className={getActive(url, ['/offices'])}>
              <IconProfile className="hover-color" style={{ height: '23px' }} />
              {t('PAGES:OFFICES')}
            </Link>
          )}

        {!newIsAdmin && CUSTOMERS_ALLOWED_TYPES.includes(profile.type) && (
          <Link
            to={'/my-customers'}
            className={getActive(url, ['/my-customers'])}
          >
            <IconProfile className="hover-color" /> {t('PAGES:CUSTOMER_EXTRA')}
          </Link>
        )}

        {!newIsAdmin &&
          [
            ...ENERGY_USERS,
            'ADMIN_COLLAB',
            'UTILIZER',
            'COMMERCIAL',
            'ASSOCIATION',
          ].includes(profileType) && (
            <div style={{ marginBottom: 25 }}>
              <button
                type="button"
                className={
                  'link-menu-btn d-flex align-items-center ' +
                  getActive(url, ['/contracts', '/my-recurring-fees'])
                }
                onClick={() => toggleDropdown('energy')}
                style={{
                  textAlign: 'left',
                  paddingLeft: 0,
                  background: 'none',
                  border: 'none',
                  width: '100%',
                }}
              >
                <span
                  style={{
                    marginLeft: 8,
                    marginRight: 15,
                    transition: 'transform 0.2s',
                  }}
                >
                  <i
                    className="fas fa-chevron-right hover-color"
                    style={{
                      transform: dropdownsOpen.energy
                        ? 'rotate(90deg)'
                        : 'rotate(0deg)',
                      transition: 'transform 0.2s',
                    }}
                  />
                </span>
                <span className="hover-color">{t('PAGES:ENERGY_MENU')}</span>
              </button>
              {dropdownsOpen.energy && (
                <div className="submenu-links">
                  <Link
                    to="/contracts"
                    className={getActive(url, ['/contracts']) + ' submenu-link'}
                  >
                    <IcnDocument className="hover-color" />
                    {t('PAGES:PARTNER_EON_MENU')}
                  </Link>
                  <Link
                    to="/my-recurring-fees"
                    className={
                      getActive(url, ['/my-recurring-fees']) + ' submenu-link'
                    }
                  >
                    <IcnDocument className="hover-color" />
                    {t('PAGES:MY_RECURRING_FEES_MENU')}
                  </Link>
                </div>
              )}
            </div>
          )}

        {!newIsAdmin && profileType === 'EON_ENERGY' && (
          <Link
            to={'/user-profiles'}
            className={getActive(url, [
              '/user-profiles',
              '/user-profile-detail',
            ])}
          >
            <IconRegistries className="hover-color" /> {t('REGISTRIES')}
          </Link>
        )}

        {!newIsAdmin && ['UTILIZER'].includes(profileType) && (
          <Link
            to={'/recurrent-contracts'}
            className={getActive(url, ['/recurrent-contracts'])}
          >
            <IcnDocument className="hover-color" /> {t('RECURRENT_CONTRACTS')}
          </Link>
        )}

        {!newIsAdmin && profileType === 'EON_ENERGY' && (
          <Link
            to={'/my-eon-condos'}
            className={getActive(url, ['/my-eon-condos'])}
          >
            <IconBuilding className="hover-color" /> {t('CONDOS')}
          </Link>
        )}

        {!newIsAdmin &&
          ([
            ...FINANCIAL_REPORTS_ALLOWED_TYPES,
            'COMMERCIAL',
            'SUPPLIER',
            'EON_ENERGY',
            'ASSOCIATION',
          ].includes(profileType) ||
            profile.superCollab === true) && (
            <Link
              to={'/my-financial-reports'}
              className={getActive(url, ['/my-financial-reports'])}
            >
              <IconFinancial className="hover-color" />
              {t('PAGES:FINANCIAL_REPORTS')}
            </Link>
          )}

        {!newIsAdmin &&
          ([...AFFILIATIONS_ALLOWED_TYPES, 'UTILIZER'].includes(profileType) ||
            profile.superCollab === true) && (
            <Link
              to={'/my-affiliations'}
              className={getActive(url, ['/my-affiliations'])}
            >
              <IconAffiliations
                className="hover-color"
                style={{ height: '23px' }}
              />
              {t('CONTACTS:AFFILIATIONS')}
            </Link>
          )}

        {!newIsAdmin && INVOICES_ALLOWED_TYPES.includes(profileType) && (
          <Link
            to={'/my-invoices'}
            className={getActive(url, ['/my-invoices'])}
          >
            <IconInvoices className="hover-color" style={{ height: '23px' }} />
            {profileType === 'SUPPLIER' ? t('INVOICES') : t('CONSULTING')}
          </Link>
        )}

        {!newIsAdmin && INVOICES_ALLOWED_TYPES.includes(profileType) && (
          <Link
            to={'/my-by-month'}
            className={getActive(url, ['/my-by-month'])}
          >
            <IconCalendar className="hover-color" />
            {t('PAGES:INVOICES_BY_MONTH')}
          </Link>
        )}

        {!newIsAdmin &&
          ([
            ...ROYALTIES_ALLOWED_TYPES,
            'UTILIZER',
            'COMMERCIAL',
            'ASSOCIATION',
          ].includes(profileType) ||
            profileType === 'ADMIN_COLLAB') && (
            <Link
              to={'/my-royalties'}
              className={getActive(url, ['/my-royalties'])}
            >
              <IconInvoices
                className="hover-color"
                style={{ height: '23px' }}
              />
              {t('PAGES:INVOICES_AND_PAYMENTS')}
            </Link>
          )}

        {!newIsAdmin &&
          ((profileType !== 'AGENCY' &&
            ROYALTIES_ALLOWED_TYPES.includes(profileType)) ||
            profile.superCollab === true) && (
            <Link
              to={'/my-studio-invoices'}
              className={getActive(url, ['/my-studio-invoices'])}
            >
              <IconInvoices
                className="hover-color"
                style={{ height: '23px' }}
              />
              {t('PAGES:STUDIO_INVOICES')}
            </Link>
          )}

        {!newIsAdmin &&
          ['EON_ENERGY', 'SUPPLIER', 'COMMERCIAL'].includes(profileType) && (
            <Link
              to={`/my-received-extra-invoice?year=${new Date().getFullYear()}`}
              className={getActive(url, ['/my-received-extra-invoice'])}
            >
              <IconInvoices
                className="hover-color"
                style={{ height: '23px' }}
              />
              {t('PAGES:EXTRA_INVOICE_RECEIVED')}
            </Link>
          )}

        {!newIsAdmin &&
          ([...ROYALTIES_ALLOWED_TYPES, 'COMMERCIAL', 'ASSOCIATION'].includes(
            profileType
          ) ||
            profile.superCollab === true) && (
            <Link
              to={'/my-received-iaf'}
              className={getActive(url, ['/my-received-iaf'])}
            >
              <IconInvoices
                className="hover-color"
                style={{ height: '23px' }}
              />
              {t('PAGES:IAF_RECEIVED')}
            </Link>
          )}

        {!newIsAdmin && ADMIN_TYPES.includes(profileType) && (
          <Link
            to={'/my-collaborators'}
            className={getActive(url, ['/my-collaborators'])}
          >
            <IconRegistries
              className="hover-color"
              style={{ height: '23px' }}
            />
            {t('PAGES:COLLABORATORS')}
          </Link>
        )}

        {['MARKETING'].includes(profileType) && (
          <Link
            to={'/albo-marketing'}
            className={getActive(url, ['/albo-marketing'])}
          >
            <IconRegistries className="hover-color" /> {t('ALBO')}
          </Link>
        )}

        {!newIsAdmin && ['MARKETING'].includes(profileType) && (
          <Link to={'/contacts'} className={getActive(url, ['/contacts'])}>
            <IconProfile className="hover-color" /> {t('CONTACTS')}
          </Link>
        )}

        {!newIsAdmin && ['MARKETING'].includes(profileType) && (
          <Link
            to={'/interactions'}
            className={getActive(url, ['/interactions'])}
          >
            <BsChatDots className="hover-color" /> {t('INTERACTIONS')}
          </Link>
        )}

        {!newIsAdmin && ['MARKETING'].includes(profileType) && (
          <Link to={'/qr-codes'} className={getActive(url, ['/qr-codes'])}>
            <BsQrCode className="hover-color" /> {t('QR_CODES')}
          </Link>
        )}

        {!newIsAdmin &&
          ![
            CERTIFIER_TYPE.CERTIFIER,
            'LAWYER',
            'UTILIZER',
            'MARKETING',
          ].includes(profileType) && (
            <Link to={'/albo'} className={getActive(url, ['/albo'])}>
              <IconRegistries className="hover-color" /> {t('ALBO')}
            </Link>
          )}

        {!newIsAdmin &&
          [...ADMIN_TYPES, 'SUPPLIER', 'ADMIN_COLLAB'].includes(
            profileType
          ) && (
            <div style={{ marginBottom: 25 }}>
              <button
                type="button"
                className={
                  'link-menu-btn d-flex align-items-center ' +
                  getActive(url, [
                    '/activities',
                    '/agreements',
                    '/external-agreements',
                  ])
                }
                onClick={() => toggleDropdown('agreements')}
                style={{
                  textAlign: 'left',
                  paddingLeft: 0,
                  background: 'none',
                  border: 'none',
                  width: '100%',
                }}
              >
                <span
                  style={{
                    marginLeft: 8,
                    marginRight: 15,
                    transition: 'transform 0.2s',
                  }}
                >
                  <i
                    className="fas fa-chevron-right hover-color"
                    style={{
                      transform: dropdownsOpen.agreements
                        ? 'rotate(90deg)'
                        : 'rotate(0deg)',
                      transition: 'transform 0.2s',
                    }}
                  />
                </span>
                <span className="hover-color">
                  {t('PAGES:AGREEMENTS_MENU')}
                </span>
              </button>
              {dropdownsOpen.agreements && (
                <div className="submenu-links">
                  {[...ADMIN_TYPES, 'ADMIN_COLLAB'].includes(profileType) && (
                    <Link
                      to="/activities"
                      className={
                        getActive(url, ['/activities']) + ' submenu-link'
                      }
                    >
                      <IcnDocument className="hover-color" />
                      {t('PAGES:ACTIVITIES')}
                    </Link>
                  )}
                  <Link
                    to="/agreements"
                    className={
                      getActive(url, ['/agreements']) + ' submenu-link'
                    }
                  >
                    <IcnDocument className="hover-color" />
                    {t('PAGES:AGREEMENTS')}
                  </Link>
                  <Link
                    to="/external-agreements"
                    className={
                      getActive(url, ['/external-agreements']) + ' submenu-link'
                    }
                  >
                    <IcnDocument className="hover-color" />
                    {t('PAGES:EXTERNAL_AGREEMENTS')}
                  </Link>
                </div>
              )}
            </div>
          )}

        {(commercial ||
          (profile.type === 'ADMIN_COLLAB' &&
            profile.isAdminCommercial === true)) && (
          <>
            <Link to={'/network'} className={getActive(url, ['/network'])}>
              <IconNetwork className="hover-color" /> {t('COMMERCIAL:NETWORK')}
            </Link>
            <Link
              to={'/my-network-financial-reports'}
              className={getActive(url, ['/my-network-financial-reports'])}
            >
              <IconFinancial className="hover-color" />
              {t('PAGES:NETWORK_FINANCIAL_REPORTS')}
            </Link>
          </>
        )}

        {([
          ...ADMIN_TYPES,
          'COMMERCIAL',
          'SUPPLIER',
          'AGENCY',
          'EON_ENERGY',
          'ASSOCIATION',
        ].includes(profileType) ||
          profile.superCollab === true) && (
          <Link
            to={'/my-give-and-take'}
            className={getActive(url, ['/my-give-and-take'])}
          >
            <IcnDocument className="hover-color" />{' '}
            {t('PAGES:MY_GIVE_AND_TAKE')}
          </Link>
        )}

        {([
          ...ADMIN_TYPES,
          'COMMERCIAL',
          'SUPPLIER',
          'AGENCY',
          'ASSOCIATION',
        ].includes(profileType) ||
          profile.superCollab) && (
          <div style={{ marginBottom: 25 }}>
            <button
              type="button"
              className={
                'link-menu-btn d-flex align-items-center ' +
                getActive(url, ['/my-signals-received', '/my-signals-sent'])
              }
              onClick={() => toggleDropdown('mySignals')}
              style={{
                textAlign: 'left',
                paddingLeft: 0,
                background: 'none',
                border: 'none',
                width: '100%',
              }}
            >
              <span
                style={{
                  marginLeft: 8,
                  marginRight: 15,
                  transition: 'transform 0.2s',
                }}
              >
                <i
                  className="fas fa-chevron-right hover-color"
                  style={{
                    transform: dropdownsOpen.mySignals
                      ? 'rotate(90deg)'
                      : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                  }}
                />
              </span>
              <span className="hover-color">{t('PAGES:MY_SIGNALS_MENU')}</span>
            </button>
            {dropdownsOpen.mySignals && (
              <div className="submenu-links">
                <Link
                  to="/my-signals-received"
                  className={
                    getActive(url, ['/my-signals-received']) + ' submenu-link'
                  }
                >
                  <IcnDocument className="hover-color" />
                  {t('PAGES:MY_SIGNALS_RECEIVED_MENU')}
                </Link>
                <Link
                  to="/my-signals-sent"
                  className={
                    getActive(url, ['/my-signals-sent']) + ' submenu-link'
                  }
                >
                  <IcnDocument className="hover-color" />
                  {t('PAGES:MY_SIGNALS_SENT_MENU')}
                </Link>
              </div>
            )}
          </div>
        )}

        {!newIsAdmin && ADMIN_TYPES.includes(profileType) && (
          <Link
            to={'/credit-calculation'}
            className={getActive(url, ['/credit-calculation'])}
          >
            <IconInvoices className="hover-color" />{' '}
            {t('PAGES:CREDIT_CALCULATION')}
          </Link>
        )}

        {!newIsAdmin && (
          <Link
            to={'/notifications'}
            className={getActive(url, ['/notifications'])}
          >
            <IconInvoices className="hover-color" /> {t('NOTIFICATIONS')}
          </Link>
        )}

        <Link to={'/info'} className={getActive(url, ['/info'])}>
          <IconProfile className="hover-color" /> {t('COMMON:INFO')}
        </Link>
      </div>
    </>
  );
}

export default withRouter(LinkMenu);
